//Arival Data
export const arrivalData = [
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Date-01_765x.jpg?v=1672052812",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Date-03_480x.jpg?v=1668705098",
      title: "DATE WOMAN PERFUME, 100ml",
      desc: "Eau De Parfum For Women",
      disscount: -30,
      price: 699,
      origionalPrice: 999,
      rating: 4.8,
      type: "",
      id:1,
   },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Senorita-01_480x.jpg?v=1668408065",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Senorita-05_25aa871e-2f6d-4947-a943-a0ed3d2a20bb_480x.jpg?v=1669873674",
      title: "SENORITA WOMAN PERFUME, 100ml",
      desc: "Eau De Parfum",
      disscount: -30,
      price: 629,
      origionalPrice: 899,
      rating: 4.8,
      type: "best",
      id:2,
   },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/SenoritaWomanGiftSet-01_aeff4eef-1fa9-4582-8220-6ac2790f90c4_480x.jpg?v=1669549387",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/SenoritaWomanGiftSet-02_b97a6db5-cb0d-4a90-9890-d48dbea8c813_480x.jpg?v=1669549387",
      title: "SENORITA WOMAN Gift Set",
      desc: "Senorita Woman Gift Set, Eau De Parfum, Body Wash, Body Lotion",
      disscount: -19,
      price: 1299,
      origionalPrice: 1599,
      rating: 4.8,
      type: "",
      id:3,
   },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/RoseWomanGiftSet-01_3452e46f-388f-4383-878d-f9ef197ce431_480x.jpg?v=1669549093",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/RoseWomanGiftSet-02_07db41cf-a72d-457a-988b-7c26fa881872_480x.jpg?v=1669549093",
      title: "ROSE WOMAN Gift Set",
      desc: "Rose Woman Gift Set, Eau De Parfum, Body Wash, Body Lotion",
      disscount: -20,
      price: 1199,
      origionalPrice: 1499,
      rating: 4.8,
      type: "",
      id:4,
   },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/SKAI-AQUATIC-Gift-set-01_480x.jpg?v=1669548879",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/SKAI-AQUATIC-Gift-set-02_480x.jpg?v=1669548878",
      title: "Skai Aquatic Gift Set",
      desc: "SKAI Aquatic Gift Set, Body Parfum, Eau De Cologne, Body Wash",
      disscount: -23,
      price: 999,
      origionalPrice: 1299,
      rating: 4.7,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/SenoritaWomenBodyWash-04_480x.jpg?v=1666962975",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/senorita_480x.jpg?v=1666962975",
      title: "SENORITA WOMAN Body Wash",
      desc: "Senorita Woman Body Wash, Floral, Hydrating, Nourishing, Moisturising, Body Wash",
      disscount: -13,
      price: 349,
      origionalPrice: 399,
      rating: 4.8,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/RoseWomenBodylotion-04_480x.jpg?v=1666962961",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/roselotion_480x.jpg?v=1666962961",
      title: "ROSE WOMAN Body Lotion",
      desc: "Rose Woman Body Lotion, Moisturising, Hydrating",
      disscount: -12,
      price: 375,
      origionalPrice: 425,
      rating: 5.0,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/CEOMANGiftSet-01_480x.jpg?v=1669549232",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/3_7d0239ec-ac1b-4aa2-bf05-0ef8f8637ddd_480x.jpg?v=1669549232",
      title: "CEO Man Gift Set",
      desc: "CEO Man Gift Set, Body Parfum, Eau De Parfum, Body Wash",
      disscount: -20,
      price: 1199,
      origionalPrice: 1499,
      rating: 5.0,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/RoseWomenBodyWash-04_3c3cc8e8-f565-4ecc-9b98-2aec8c28ec0b_480x.jpg?v=1666962880",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/rosewoman_480x.jpg?v=1666962880",
      title: "ROSE WOMAN Body Wash",
      desc: "Rose Woman Body Wash, Floral, Hydrating, Nourishing, Moisturising, Body Wash",
      disscount: -13,
      price: 349,
      origionalPrice: 399,
      rating: 5.0,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/SkaiBodyWash-04_480x.jpg?v=1666962820",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/SkaiBodyWash-01_480x.jpg?v=1666962820",
      title: "SKAI AQUATIC Body Wash",
      desc: "SKAI Aquatic Body Wash, Fragrant, Hydrating, Moisturising, Body Wash",
      disscount: -13,
      price: 349,
      origionalPrice: 399,
      rating: 4.8,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/SenoritaWomenBodyLotion-04_480x.jpg?v=1666962795",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/senoritalotion_480x.jpg?v=1666962795",
      title: "SENORITA WOMAN Body Lotion",
      desc: "Senorita Woman Body Lotion, Moisturising, Hydrating BVL: Moisturiser",
      disscount: -12,
      price: 375,
      origionalPrice: 425,
      rating: 5.0,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/CEOManBodyWash-04_480x.jpg?v=1666962772",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/CEOman_480x.jpg?v=1666962772",
      title: "CEO MAN Body Wash",
      desc: "CEO Man Body Wash, Hydrate, Moisturise, Deep Cleanses, Body Wash",
      disscount: -13,
      price: 349,
      origionalPrice: 399,
      rating: 5.0,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Hydra-plusNightCream-03_480x.jpg?v=1654165749",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/568_480x.jpg?v=1668162931",
      title: "Hydra-Plus Night Cream ,50gm",
      desc: "Hydrating, Repairing And Nourishing",
      disscount: -24,
      price: 381,
      origionalPrice: 499,
      rating: 4.8,
      type: "best",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Hydra-Plus-Face-Gel-03_480x.jpg?v=1654164918",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/HydraGel_480x.jpg?v=1655309460",
      title: "Hydra-Plus Face Gel ,50gm",
      desc: "Hydrating & Moisturising",
      disscount: -13,
      price: 349,
      origionalPrice: 399,
      rating: 4.6,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/HydraplusFaceWash-03_480x.jpg?v=1654164895",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/464_480x.jpg?v=1668162842",
      title: "Hydra-Plus Face Wash ,100ml",
      desc: "Hydrating, Cleansing & Brightening",
      disscount: -19,
      price: 225,
      origionalPrice: 279,
      rating: 4.8,
      type: "",
    },
 ];
  
  // Best Sellers
  export const bestSeller = [
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/ManBox-01_765x.jpg?v=1652421642",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/188_765x.jpg?v=1668167835",
      desc: "Eau De Parfum",
      type: "Best",
      price: 575,
      origionalPrice: 849,
      rating: 4.6,
      disscount: 32,
      title: "Luxury Perfume Gift Set For Man - 4x20ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/UnisexBox-01_765x.jpg?v=1652421720",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/274_765x.jpg?v=1668171935",
      desc: "Eau De Parfum",
      type: "Best",
      price: 575,
      origionalPrice: 849,
      rating: 4.6,
      disscount: 32,
      title: "Luxury Unisex Perfume Gift Set - 4x20ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/WomanBox-01_9b8b1187-fb16-4397-907e-fa53dbd38977_765x.jpg?v=1652421568",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/WomanBox-02_b1dec0dd-86d5-4035-822d-1cbfa00c5470_765x.jpg?v=1652421570",
      desc: "Eau De Perfum",
      type: "Best",
      price: 575,
      origionalPrice: 849,
      rating: 4.7,
      disscount: 32,
      title: "Luxury Perfume Gift Set For Woman - 4x20ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Eyelift-01Medium_765x.jpg?v=1659101492",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/WomenandmenEyelift_408e9507-e921-45f4-bb81-325f068dbf55_765x.jpg?v=1663058248",
      desc: "Repairs Dark Circles, Puffy Eyes & Wrinkles",
      type: "Best",
      price: 235,
      origionalPrice: 325,
      rating: 4.7,
      disscount: 28,
      title: "EyeLift Under Eye Cream, 20gm",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Exfoliate-01_1_Medium_a7654ecf-8f6c-4b46-9d27-f3c5e8a30f28_765x.jpg?v=1659101350",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Exfoliate-02Medium_765x.jpg?v=1669804522",
      desc: "Gentle Exfoliation, Nourishing & Skin Brightening",
      type: "Best",
      price: 195,
      origionalPrice: 275,
      rating: 4.8,
      disscount: 29,
      title: "Exfoliate Face And Body Scrub Grit, 75gm",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-GlowFaceWash-01Medium_765x.jpg?v=1659101821",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-GlowFaceWash-02Medium_765x.jpg?v=1659101821",
      desc: "De-Tan & Brightening",
      type: "Best",
      price: 185,
      origionalPrice: 249,
      rating: 4.7,
      disscount: 26,
      title: "C-Glow Face Wash, 100ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/De-Tan-01_3465a124-f199-4478-96d0-65c20b17fa0b_765x.jpg?v=1667202285",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/125_765x.jpg?v=1668166033",
      desc: "Detan & Skin Brightening",
      type: "Best",
      price: 325,
      origionalPrice: 399,
      rating: 4.8,
      disscount: 19,
      title: "De Tan Face Pack For Glowing Skin,100gm",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/DeoWhiteMen-01_2_765x.jpg?v=1651698262",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/DeoWhiteMen-02_765x.jpg?v=1652081039",
      desc: "Underarm Skin Whitening",
      type: "no",
      price: 185,
      origionalPrice: 199,
      rating: 4.7,
      disscount: 7,
      title: "Deo White Natural Roll On Deodorant For Men, 50ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/SkaiAquatic-01_765x.jpg?v=1652422766",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/SkaiAquatic-02_a463a5ee-21f5-43e4-b878-bebf47e35a47_765x.jpg?v=1661759829",
      desc: "Eau De Cologne",
      type: "Best",
      price: 525,
      origionalPrice: 699,
      rating: 4.9,
      disscount: 25,
      title: "SKAI AQUATIC UNISEX PERFUME, 100ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/CEOMAN-01_cf6cf834-200c-42bf-81a7-e80dbee17c7d_765x.jpg?v=1652421979",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/352_765x.jpg?v=1669382634",
      desc: "Eau De Parfum",
      type: "Best",
      price: 525,
      origionalPrice: 899,
      rating: 4.5,
      disscount: 42,
      title: "CEO MAN LUXURY PERFUME, 100ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/NicoBalm-01_6c683236-3694-4219-8fee-e969bbf9e94d_765x.jpg?v=1640436778",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/NicoBalm-02_93beb060-c566-487f-91cf-254d5f81c1e6_765x.jpg?v=1641286093",
      desc: "Hydrating & Nourishing",
      type: "no",
      price: 205,
      origionalPrice: 225,
      rating: 4.7,
      disscount: 9,
      title: "The Lip Balm , 5gm",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/640_765x.jpg?v=1668161406",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/NicoLips-02Medium_765x.jpg?v=1668161406",
      desc: "Lip Brightening, Nourishing & Repairing",
      type: "Best",
      price: 315,
      origionalPrice: 450,
      rating: 4.7,
      disscount: 30,
      title: "NicoLips Lip Brightening Scrub, 20gm",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/OUD-01_5d17f334-cc6c-4fe1-b230-cb95f79726ab_765x.jpg?v=1652422383",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/OUD-02_72758606-c71e-4475-9616-59ceb8844303_765x.jpg?v=1661756694",
      desc: "Parfum",
      type: "Best",
      price: 679,
      origionalPrice: 999,
      rating: 4.7,
      disscount: 32,
      title: "OUD UNISEX LUXURY PERFUME, 100ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/WhiteOUD-01_5eb2f95c-36ef-4c3b-a450-657c6dc6f420_765x.jpg?v=1652422287",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/WhiteOUD-02_765x.jpg?v=1661759789",
      desc: "Eau De Parfum",
      type: "Best",
      price: 699,
      origionalPrice: 999,
      rating: 4.7,
      disscount: 30,
      title: "WHITE OUD UNISEX, 100ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/IMPACT-01_765x.jpg?v=1652422894",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/680_765x.jpg?v=1668168463",
      desc: "Eau De Cologne",
      type: "Best",
      price: 629,
      origionalPrice: 899,
      rating: 4.6,
      disscount: 30,
      title: "IMPACT MAN PERFUME, 100ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/perfume1_1_765x.jpg?v=1671604477",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/CEOMAN-05_765x.webp?v=1671604477",
      desc: "5 Masculine Fragrances",
      type: "Best",
      price: 1999,
      origionalPrice: 4395,
      rating: 4.7,
      disscount: 55,
      title: "Ultimate Men's Selection",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/perfume2_765x.jpg?v=1671604735",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/CEOMAN-05_a7da118f-f1a3-4401-ba1f-83b11b362e78_765x.webp?v=1671604736",
      desc: "Family Combo",
      type: "Best",
      price: 1999,
      origionalPrice: 4595,
      rating: 4.7,
      disscount: 56,
      title: "Refreshing You Combo",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/perfume3_765x.jpg?v=1671604950",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/ceowoman_765x.webp?v=1671604949",
      desc: "5 Premium Feminine Scents",
      type: "Best",
      price: 1999,
      origionalPrice: 4695,
      rating: 4.6,
      disscount: 57,
      title: "Everready Women Combo",
    },
  ];
  
  //Shop All
  export const shopAll = [
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/ManBox-01_765x.jpg?v=1652421642",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/188_765x.jpg?v=1668167835",
      desc: "Eau De Parfum",
      type: "Best",
      price: 575,
      origionalPrice: 849,
      rating: 4.6,
      disscount: 32,
      title: "Luxury Perfume Gift Set For Man - 4x20ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Date-01_765x.jpg?v=1672052812",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Date-03_480x.jpg?v=1668705098",
      title: "DATE WOMAN PERFUME, 100ml",
      desc: "Eau De Parfum For Women",
      disscount: -30,
      price: 699,
      origionalPrice: 999,
      rating: 4.8,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/UnisexBox-01_765x.jpg?v=1652421720",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/274_765x.jpg?v=1668171935",
      desc: "Eau De Parfum",
      type: "Best",
      price: 575,
      origionalPrice: 849,
      rating: 4.6,
      disscount: 32,
      title: "Luxury Unisex Perfume Gift Set - 4x20ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/HydraplusFaceWash-03_480x.jpg?v=1654164895",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/464_480x.jpg?v=1668162842",
      title: "Hydra-Plus Face Wash ,100ml",
      desc: "Hydrating, Cleansing & Brightening",
      disscount: -19,
      price: 225,
      origionalPrice: 279,
      rating: 4.8,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/WomanBox-01_9b8b1187-fb16-4397-907e-fa53dbd38977_765x.jpg?v=1652421568",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/WomanBox-02_b1dec0dd-86d5-4035-822d-1cbfa00c5470_765x.jpg?v=1652421570",
      desc: "Eau De Perfum",
      type: "Best",
      price: 575,
      origionalPrice: 849,
      rating: 4.7,
      disscount: 32,
      title: "Luxury Perfume Gift Set For Woman - 4x20ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Hydra-Plus-Face-Gel-03_480x.jpg?v=1654164918",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/HydraGel_480x.jpg?v=1655309460",
      title: "Hydra-Plus Face Gel ,50gm",
      desc: "Hydrating & Moisturising",
      disscount: -13,
      price: 349,
      origionalPrice: 399,
      rating: 4.6,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Hydra-plusNightCream-03_480x.jpg?v=1654165749",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/568_480x.jpg?v=1668162931",
      title: "Hydra-Plus Night Cream ,50gm",
      desc: "Hydrating, Repairing And Nourishing",
      disscount: -24,
      price: 381,
      origionalPrice: 499,
      rating: 4.8,
      type: "best",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Eyelift-01Medium_765x.jpg?v=1659101492",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/WomenandmenEyelift_408e9507-e921-45f4-bb81-325f068dbf55_765x.jpg?v=1663058248",
      desc: "Repairs Dark Circles, Puffy Eyes & Wrinkles",
      type: "Best",
      price: 235,
      origionalPrice: 325,
      rating: 4.7,
      disscount: 28,
      title: "EyeLift Under Eye Cream, 20gm",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Exfoliate-01_1_Medium_a7654ecf-8f6c-4b46-9d27-f3c5e8a30f28_765x.jpg?v=1659101350",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Exfoliate-02Medium_765x.jpg?v=1669804522",
      desc: "Gentle Exfoliation, Nourishing & Skin Brightening",
      type: "Best",
      price: 195,
      origionalPrice: 275,
      rating: 4.8,
      disscount: 29,
      title: "Exfoliate Face And Body Scrub Grit, 75gm",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-GlowFaceWash-01Medium_765x.jpg?v=1659101821",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-GlowFaceWash-02Medium_765x.jpg?v=1659101821",
      desc: "De-Tan & Brightening",
      type: "Best",
      price: 185,
      origionalPrice: 249,
      rating: 4.7,
      disscount: 26,
      title: "C-Glow Face Wash, 100ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/SenoritaWomenBodyWash-04_480x.jpg?v=1666962975",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/senorita_480x.jpg?v=1666962975",
      title: "SENORITA WOMAN Body Wash",
      desc: "Senorita Woman Body Wash, Floral, Hydrating, Nourishing, Moisturising, Body Wash",
      disscount: -13,
      price: 349,
      origionalPrice: 399,
      rating: 4.8,
      type: "",
    }, {
     img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/RoseWomenBodylotion-04_480x.jpg?v=1666962961",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/roselotion_480x.jpg?v=1666962961",
      title: "ROSE WOMAN Body Lotion",
      desc: "Rose Woman Body Lotion, Moisturising, Hydrating",
      disscount: -12,
      price: 375,
      origionalPrice: 425,
      rating: 5.0,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/RoseWomenBodyWash-04_3c3cc8e8-f565-4ecc-9b98-2aec8c28ec0b_480x.jpg?v=1666962880",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/rosewoman_480x.jpg?v=1666962880",
      title: "ROSE WOMAN Body Wash",
      desc: "Rose Woman Body Wash, Floral, Hydrating, Nourishing, Moisturising, Body Wash",
      disscount: -13,
      price: 349,
      origionalPrice: 399,
      rating: 5.0,
      type: "",
    },
   {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/De-Tan-01_3465a124-f199-4478-96d0-65c20b17fa0b_765x.jpg?v=1667202285",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/125_765x.jpg?v=1668166033",
      desc: "Detan & Skin Brightening",
      type: "Best",
      price: 325,
      origionalPrice: 399,
      rating: 4.8,
      disscount: 19,
      title: "De Tan Face Pack For Glowing Skin,100gm",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/DeoWhiteMen-01_2_765x.jpg?v=1651698262",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/DeoWhiteMen-02_765x.jpg?v=1652081039",
      desc: "Underarm Skin Whitening",
      type: "no",
      price: 185,
      origionalPrice: 199,
      rating: 4.7,
      disscount: 7,
      title: "Deo White Natural Roll On Deodorant For Men, 50ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/SkaiAquatic-01_765x.jpg?v=1652422766",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/SkaiAquatic-02_a463a5ee-21f5-43e4-b878-bebf47e35a47_765x.jpg?v=1661759829",
      desc: "Eau De Cologne",
      type: "Best",
      price: 525,
      origionalPrice: 699,
      rating: 4.9,
      disscount: 25,
      title: "SKAI AQUATIC UNISEX PERFUME, 100ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/CEOMAN-01_cf6cf834-200c-42bf-81a7-e80dbee17c7d_765x.jpg?v=1652421979",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/352_765x.jpg?v=1669382634",
      desc: "Eau De Parfum",
      type: "Best",
      price: 525,
      origionalPrice: 899,
      rating: 4.5,
      disscount: 42,
      title: "CEO MAN LUXURY PERFUME, 100ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/NicoBalm-01_6c683236-3694-4219-8fee-e969bbf9e94d_765x.jpg?v=1640436778",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/NicoBalm-02_93beb060-c566-487f-91cf-254d5f81c1e6_765x.jpg?v=1641286093",
      desc: "Hydrating & Nourishing",
      type: "no",
      price: 205,
      origionalPrice: 225,
      rating: 4.7,
      disscount: 9,
      title: "The Lip Balm , 5gm",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/640_765x.jpg?v=1668161406",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/NicoLips-02Medium_765x.jpg?v=1668161406",
      desc: "Lip Brightening, Nourishing & Repairing",
      type: "Best",
      price: 315,
      origionalPrice: 450,
      rating: 4.7,
      disscount: 30,
      title: "NicoLips Lip Brightening Scrub, 20gm",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/OUD-01_5d17f334-cc6c-4fe1-b230-cb95f79726ab_765x.jpg?v=1652422383",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/OUD-02_72758606-c71e-4475-9616-59ceb8844303_765x.jpg?v=1661756694",
      desc: "Parfum",
      type: "Best",
      price: 679,
      origionalPrice: 999,
      rating: 4.7,
      disscount: 32,
      title: "OUD UNISEX LUXURY PERFUME, 100ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/WhiteOUD-01_5eb2f95c-36ef-4c3b-a450-657c6dc6f420_765x.jpg?v=1652422287",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/WhiteOUD-02_765x.jpg?v=1661759789",
      desc: "Eau De Parfum",
      type: "Best",
      price: 699,
      origionalPrice: 999,
      rating: 4.7,
      disscount: 30,
      title: "WHITE OUD UNISEX, 100ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/IMPACT-01_765x.jpg?v=1652422894",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/680_765x.jpg?v=1668168463",
      desc: "Eau De Cologne",
      type: "Best",
      price: 629,
      origionalPrice: 899,
      rating: 4.6,
      disscount: 30,
      title: "IMPACT MAN PERFUME, 100ml",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/perfume1_1_765x.jpg?v=1671604477",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/CEOMAN-05_765x.webp?v=1671604477",
      desc: "5 Masculine Fragrances",
      type: "Best",
      price: 1999,
      origionalPrice: 4395,
      rating: 4.7,
      disscount: 55,
      title: "Ultimate Men's Selection",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/perfume2_765x.jpg?v=1671604735",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/CEOMAN-05_a7da118f-f1a3-4401-ba1f-83b11b362e78_765x.webp?v=1671604736",
      desc: "Family Combo",
      type: "Best",
      price: 1999,
      origionalPrice: 4595,
      rating: 4.7,
      disscount: 56,
      title: "Refreshing You Combo",
    },
    {
      img1: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/perfume3_765x.jpg?v=1671604950",
      img2: "https://cdn.shopify.com/s/files/1/0054/6665/2718/products/ceowoman_765x.webp?v=1671604949",
      desc: "5 Premium Feminine Scents",
      type: "Best",
      price: 1999,
      origionalPrice: 4695,
      rating: 4.6,
      disscount: 57,
      title: "Everready Women Combo",
    },
  ];
//Spotlight Data

  export const spotlight=[
    {
      id:5,
      title:"Best Sellers",
      img:"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Skin_Care_V1_Medium_480x_09916d9f-fa9c-4a77-bfd3-481d87f0026f_480x.jpg?v=1668751543"
    },
    {
      id:1,
      title:"Shop All",
      img:"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Hair_Care_V1.1_Medium_480x_ed1ab255-51c6-468b-86b3-30e37348113d_480x.jpg?v=1668751634"
    },
    {
      id:2,
      title:"New Arrival",
      img:"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Body_Care_V2_Medium_480x_12ed3d42-d313-4f2e-ad0f-4b3152aa5b9d_480x.jpg?v=1668751616"
    },
    {
      id:3,
      title:"Summer Essential",
      img:"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Summer_Essentials_V1_Medium_480x_b1fae592-7dc5-46e3-872f-8702236907cf_480x.jpg?v=1668751664"
    },
    {
      id:4,
      title:"Sensitive Skin",
      img:"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Sensitive_Skin_V1_Medium_480x_2a4eee81-456d-4a54-ba83-0d39f6976288_480x.jpg?v=1668751683"
    }
  ]
  
  // Solution Data
export const solution = [{
  id:1,
  img:"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Tan_Removal_Medium_1_480x_582f8a80-0916-47e7-ab8a-394206c29927_900x.jpg?v=1668753363"
  },
  {
    id:2,
    img: "https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Dry___Dull_Lips_Medium_480x_53454fe1-806f-4a40-9ae6-fe9eef93071d_900x.jpg?v=1668753515"
  },
  {
    id:3,
    img: "https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Dark_Circles_Medium_1_480x_61dec845-22cf-4aed-824d-8a6d771fda32_900x.jpg?v=1668753529"
  },
  {
    id:4,
    img: "https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Pimples-Acne_Medium_480x_00cbb911-202f-4cb2-a0f7-f9ec92e6a800_900x.jpg?v=1668753551"
  },
  {
    id:5,
    img: "https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Hair-Loss-_-Thinning-V1_Medium_480x_24df57b9-a9de-4f14-9fcb-b83d43b89e74_480x.jpg?v=1668753568"
  }
  ]